////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
export default {
}
</script>

////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style>
/************************** ШРИФТЫ *******************************/
/* ЗАГРУЗКА ШРИФТОВ В ONLINE PRODUCTION РЕЖИМЕ */
/* ALT!!!: TODO: НО ТАМ НЕ ВСЕ ШРИФТЫ РАБОТАЮТ - ИЛИ НЕ РАБОТАЮТ ВООБЩЕ ИЛИ РУССКИЙ НЕ ПОДДЕРЖИВАЮТ. А вот Lato на гугле вообще нет русского*/
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i&subset=cyrillic-ext');
/*@import url('https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i&subset=cyrillic-ext');*/

/* ЗАГРУЗКИ ШРИФТОВ В OFFLINE-РЕЖИМЕ ТОЛЬКО */
/* @import "./assets/fonts/OpenSansRus/OpenSans.css"; */
/* @import "./assets/fonts/RobotoRus/Roboto.css"; */
/* @import "./assets/fonts/LatoRus/Lato.css"; */

@import url('https://fonts.googleapis.com/css2?family=Lobster&display=swap');

/********************** ОБЩЕЕ ***********************************/
html, body, #app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.0;
}
#app .hidden{
  display: none;
}
#app .text-align-center{
  text-align: center;
}

/********************* IVIEW RESTYLING **************************/
/* iview ссылка:hover*/
#app a:hover {
  color: #97b3ff;
  text-decoration: underline;
}
/* у кнопок с серым передом или задом - добавляем радиус скривления и высветляем фон */
#app .ivu-input-group-append,
#app .ivu-input-group-prepend {
  border-radius: 6px;
  background-color: #f0f0f0;
}
/* новый стиль для input с иконкой внутри чтобы она была слева */
#app .input-left-icon .ivu-input-icon-normal+.ivu-input {
  padding-left: 28px;
  padding-right: 5px;
}
#app .input-left-icon .ivu-input-icon {
  right: unset;
}
.no-circle {
  border-radius: 0px;
}
/************************************************/
/* Стилизация стандартного select */
select {
  height: 26px;
  border: 1px solid #ddd;
  border-radius: 3px;
  color: #606060;
  padding: 6px 22px 5px 7px;
  display: inline-block;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
}
select[disabled] {
  background-color: #f3f3f3;
  border: 1px solid #ddd;
}
select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000;
}
/* стилизация стрелочек select */
select {
  background-image:
    linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%);
  background-position:
    calc(100% - 12px) calc(10px),
    calc(100% - 6px) calc(10px);
  background-size:
    6px 6px,
    6px 7px;
  background-repeat: no-repeat;
}
select:focus {
  background-image:
    linear-gradient(45deg, gray 50%, transparent 50%),
    linear-gradient(135deg, transparent 50%, gray 50%);
  background-position:
    calc(100% - 6px) 10px,
    calc(100% - 12px) 10px;
  background-size:
    6px 6px,
    6px 6px;
  background-repeat: no-repeat;
  outline: 0;
  border: 1px solid #909090;
}
/* Конец стилизации стандартного select */
/************************************************/
ul {
  margin-left: 17px;
  padding-left: 10px;
  list-style-type: disc;
}
ol {
  margin-left: 24px;
  padding-left: 0px;
  list-style-type: decimal;
}
/************************************************/
</style>

////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// App.vue?0664b702